// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2Tp1r","text":"styles_text__24yg9"};